import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  blocksDivider: {
    height: '20px',
  },
  buttonDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    type: 'button',
    cursor: 'pointer',
    marginLeft: 4,
    padding: '2px 10px',
    ':hover': {
      backgroundColor: theme.colors.gray,
      borderRadius: 9,
    },
  },
});
